const PROPERTIES_MAP = {
  title: 'title',
  description: 'description'
};

export function createBasicMetas(props = {}) {
  const allowedKeys = Object.keys(PROPERTIES_MAP);

  return allowedKeys.filter(key => typeof props[key] !== 'undefined').reduce(
    (acc, key) => [
      ...acc,
      {
        name: PROPERTIES_MAP[key],
        content: props[key]
      }
    ],
    []
  );
}

export default {
  createBasicMetas
};
